export const ACCESS_TOKEN_COOKIE = 'arb_access_token';
export const REFRESH_TOKEN_COOKIE = 'arb_refresh_token';

/**
 * Marca de que há sessão renovável, emitida pelo core-api junto do access token.
 *
 * Existe porque `arb_refresh_token` vive em `path=/api/auth` e por isso NUNCA chega numa navegação
 * de página: o guarda de rota lia os dois cookies mas só enxergava o de 15 minutos, e mandava para
 * o `/login` quem tinha 7 dias de sessão válida. Não é credencial — quem autoriza é o core-api.
 */
export const SESSAO_RENOVAVEL_COOKIE = 'arb_sessao_renovavel';
/**
 * `__Secure-`, e não `__Host-` como a marca irmã de sessão inválida: `__Host-` proíbe `Domain`, e a
 * marca precisa dele para cruzar do host da API (`api-<env>.arbitralis.com.br`) até o host do app.
 * Cookie host-only ficaria preso à API e nunca chegaria aqui — a correção não sairia do papel.
 */
export const SESSAO_RENOVAVEL_COOKIE_SEGURO = `__Secure-${SESSAO_RENOVAVEL_COOKIE}`;

export const SESSAO_INVALIDA_COOKIE = 'arb_sessao_invalida';
export const SESSAO_INVALIDA_COOKIE_SEGURO = `__Host-${SESSAO_INVALIDA_COOKIE}`;
